import React from 'react'

const JsonViewer = props => {
    if (typeof window !== "undefined") {
        const ReactJson = require('react-json-view').default
        return <ReactJson {...props} />
    }
    return null
}
export default JsonViewer;